import React from 'react';

function Pagination({ hasNextPage, loadingMore, onLoadMore }) {
  if (!hasNextPage) return null;

  return (
    <div className="pagination-wrapper" style={{ textAlign: 'center' }}>
      <button className="button button--primary" type="button" onClick={onLoadMore} disabled={loadingMore}>
        {loadingMore ? 'Loading…' : 'Load more'}
      </button>
    </div>
  );
}

export default Pagination;
